import BasePresenter from '@src/js/separate-logic/base-presenter';

export default class GroupElementWrapperPresenter extends BasePresenter {
    public componentDidUpdate() {
        if (!this.props.fromScale) {
            this.props.onElementUpdate?.();
        }
    }

    public get elementWrapperRef() {
        return this.getChildRef('elementWrapperRef');
    }
}
